import React, { useEffect, useState } from "react";
import { Table } from "antd";
import Cookies from "js-cookie";
import { adminMainUrl } from "../../../Config";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllLedgerAccountIdAndPartyName,
  getAllMasterBranchIdAndName,
  getAllMasterCurrencyIdAndName,
} from "../../../Redux/action/MasterAction";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Modal, Button, Spinner, Table as BootstrapTable } from "react-bootstrap";
import AccountPagination from "../../Masters/AccountMaster/GroupMaster/AccountPagination";


const VoucherProcessingReceiptSearch = ({ setActiveTab }) => {
  const token = Cookies.get("token");
  const user_id = Cookies.get("flexichain_user_id");

  const [showModal, setShowModal] = useState(false);
  const [remittanceDetails, setRemittanceDetails] = useState(null);
  const [loadingDetails, setLoadingDetails] = useState(false);

  const getRemittanceDetails = async (id) => {
    const config = {
      headers: {
        "auth-token": token,
        user_id: user_id,
        "Content-Type": "application/json",
      },
    };

    try {
      setLoadingDetails(true);

      const res = await axios.post(
        `${adminMainUrl}/api/account/remittance-clubbing-details`,
        { id: id },
        config
      );
      setRemittanceDetails(res.data.data);
      setShowModal(true);

    } catch (error) {
      console.error("Error:", error);
      toast.error(
        error?.response?.data?.message || "Failed to fetch remittance details"
      );
    } finally {
      setLoadingDetails(false);
    }
  };
  const columns = [
    { title: "Remittance No", dataIndex: "shipment_no", key: "shipment_no" },
    { title: "Date", dataIndex: "date", key: "date" },
    { title: "Currency", dataIndex: "currency", key: "currency" },
    { title: "Party Name", dataIndex: "account_name", key: "account_name" },
    { title: "Amount", dataIndex: "amount", key: "amount" },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        let cls =
          status === "Open"
            ? "badge-open"
            : status === "Partial"
              ? "badge-partial"
              : "badge-closed";

        return <span className={cls}>{status}</span>;
      },
    },

    {
      title: "Actions",
      key: "actions",
      render: (_, record) => <span className="text-primary cursor-pointer" onClick={() => getRemittanceDetails(record.key)}>View</span>,
    },
  ];

  const {
    MasterBranchName,
    MasterBranchNameError,

    loadingLedgerAccountIdAndPartyName,
    LedgerAccountIdAndPartyName,
    LedgerAccountIdAndPartyNameError,

    loadingMasterCurrencyIdAndName,
    MasterCurrencyIdAndName,
    MasterCurrencyIdAndNameError,
  } = useSelector((state) => state?.MasterReducer);

  const [receiptVoucherSearch, setReceiptVoucherSearch] = useState({
    from_date: "",
    to_date: "",
    currency: "",
    branch: "",
    party_name: "",
    remittance_status: "",
  });
  const [ReceiptVoucherCurrentPage, setReceiptVoucherCurrentPage] = useState(1);
  const [ReceiptVoucherTotalPage, setReceiptVoucherTotalPage] = useState(0);

  const [dataSourcer, setDataSourcer] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();
  const urlString = window.location.href;
  const url = new URL(urlString);
  const path = url.pathname.slice(1);
  const searchParams = url.search;
  const q = path + searchParams;
  const queryParams = new URLSearchParams(location.search);

  const searchReceiptVoucher = async (
    token,
    user_id,
    {
      page,
      from_date,
      to_date,
      branch_id,
      currency_id,
      party_name,
      status,
    },
  ) => {
    const config = {
      headers: {
        "auth-token": token,
        user_id: user_id,
        "Content-Type": "application/json",
      },
    };

    let apiUrl = `${adminMainUrl}/api/account/remittance-clubbing`;

    const queryParams = [];
    if (page) queryParams.push(`page=${page}`);
    if (from_date) queryParams.push(`from_date=${from_date}`);
    if (to_date) queryParams.push(`to_date=${to_date}`);
    if (branch_id) queryParams.push(`branch_id=${branch_id}`);
    if (currency_id) queryParams.push(`currency_id=${currency_id}`);
    if (party_name) queryParams.push(`party_name=${party_name}`);
    if (status) queryParams.push(`status=${status}`);

    if (queryParams.length > 0) {
      apiUrl += `?${queryParams.join("&")}`;
    }

    try {
      const res = await axios.get(apiUrl, config);
      // console.log("API Response:", res.data);

      // Transform data to match table columns
      const transformedData = res.data.data.map((item) => ({
        key: item.id, // required by AntD Table
        shipment_no: item.remittance_id,
        date: item.remittance_date.split("T")[0] || "-",
        currency: item.currency_master?.currency_name || "—",
        branch: item.branch_master?.name || "—",
        account_name: item.invoices_for_clubbing[0]?.party_name || "—",
        amount: item.total_amount || "—",

        status: item.status || "—",
      }));

      setDataSourcer(transformedData);
      setReceiptVoucherCurrentPage(res.data.pagination.currentPage || 1);
      setReceiptVoucherTotalPage(res.data.pagination.totalPages || 0);

    } catch (error) {
      console.error("Error fetching receipt vouchers:", error);
    }
  };

  const onValueChange = (e) => {
    const { name, type, value, checked } = e.target;

    setReceiptVoucherSearch((pre) => ({
      ...pre,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const {
    from_date,
    to_date,
    currency,
    branch,
    party_name,
    remittance_status,
  } = receiptVoucherSearch;

  const searchHandler = () => {
    if (from_date > to_date) {
      toast.error("From date cannot be greater than To date");
      return;
    }

    searchReceiptVoucher(token, user_id, {
      from_date: from_date,
      to_date: to_date,
      branch_id: branch,
      currency_id: currency,
      party_name: party_name,
      status: remittance_status,
    });
  };

  useEffect(() => {
    if (token && user_id) {
      dispatch(getAllMasterBranchIdAndName(token, user_id));
      dispatch(getAllLedgerAccountIdAndPartyName(token, user_id));
      dispatch(getAllMasterCurrencyIdAndName(token, user_id));
      searchReceiptVoucher(token, user_id, { page: 1 });
    } else {
      toast.error("Please login to continue.");
      navigate(`/login?burl=${encodeURIComponent(q)}`);
    }
  }, [token, user_id, location.search]);

  const clearForm = () => {
    setReceiptVoucherSearch({
      from_date: "",
      to_date: "",
      currency: "",
      branch: "",
      party_name: "",
      remittance_status: "",
    });
  };

  return (
    <>
      <style>
        {`
          .padding-pt-9 {
            padding: 9px;
          }
        `}
      </style>

      <div className="card p-4">
        <h5 className="fw-semibold mb-3">Remittance Search</h5>
        <div className="row">
          {/* from_date */}
          <div className="col-md-4 mb-4">
            <label className="form-label fw-medium">From Date</label>
            <input
              type="date"
              name="from_date"
              className="form-control bg-light"
              placeholder="Enter from date"
              onChange={onValueChange}
              value={receiptVoucherSearch.from_date}
            />
          </div>

          {/* to_date */}
          <div className="col-md-4 mb-4">
            <label className="form-label fw-medium">To Date</label>
            <input
              type="date"
              name="to_date"
              className="form-control bg-light"
              placeholder="Enter to date"
              onChange={onValueChange}
              value={receiptVoucherSearch.to_date}
            />
          </div>

          {/* currency */}
          <div className="col-md-4 mb-4">
            <label className="form-label fw-medium">Currency</label>
            <select
              name="currency"
              className="form-select bg-light padding-pt-9"
              value={receiptVoucherSearch.currency}
              onChange={onValueChange}
            >
              <option value="">Select currency </option>
              {MasterCurrencyIdAndName.map((item, i) => (
                <option value={item.id}>{item.currency_name}</option>
              ))}
            </select>
          </div>

          {/* branch */}
          <div className="col-md-4 mb-4">
            <label className="form-label fw-medium">Branch</label>
            <select
              name="branch"
              className="form-select bg-light padding-pt-9"
              value={receiptVoucherSearch.branch}
              onChange={onValueChange}
            >
              <option value="">Select branch</option>
              {MasterBranchName?.map((item, i) => (
                <option value={item.id}>{item.name}</option>
              ))}
            </select>
          </div>

          {/* account_name */}
          <div className="col-md-4 mb-4">
            <label className="form-label fw-medium">Party Name</label>
            <input
              type="text"
              name="party_name"
              className="form-control bg-light"
              value={receiptVoucherSearch.party_name}
              onChange={onValueChange}
              placeholder="party name"
            />
          </div>

          {/* remittance_status */}
          <div className="col-md-4 mb-4">
            <label className="form-label fw-medium">Remittance Status</label>
            <select
              name="remittance_status"
              className="form-select bg-light padding-pt-9"
              value={receiptVoucherSearch.remittance_status}
              onChange={onValueChange}
            >
              {/* Open/Partial/Closed" */}
              <option value="">Select status</option>
              <option value="Open">Open</option>
              <option value="Partial">Partial</option>
              <option value="Closed">Closed</option>
            </select>
          </div>

          {/* ACTION BUTTONS */}
          <div className="d-flex flex-wrap gap-2 mt-3">
            <button
              onClick={() => searchHandler()}
              className="btn btn-primary px-4"
            >
              <i className="fas fa-save me-1"></i> Search
            </button>

            <button
              onClick={() => clearForm()}
              className="btn btn-light border px-4"
            >
              <i className="fas fa-undo me-1"></i> Clear
            </button>

            <button className="btn btn-light border px-4">
              <i class="fa-solid fa-file-export"></i> Export
            </button>

            <button className="btn btn-danger px-4" onClick={() => { setActiveTab("remittance_clubbing") }}>
              <i class="fa-solid fa-plus"></i> New Remittance
            </button>
          </div>
        </div>
      </div>

      {/* table */}
      <div className="card p-4">
        <div className="d-flex flex-wrap justify-content-between align-items-center">
          <h5 className="fw-semibold mb-3">Remittance List</h5>
        </div>
        <div className="table-responsive custom-table query-list-table mt-4">
          <Table
            className="table datanew dataTable no-footer"
            // rowSelection={rowSelection}
            dataSource={dataSourcer}
            columns={columns}
            pagination={false}
          />
        </div>
        <AccountPagination
          currentPage={ReceiptVoucherCurrentPage}
          totalPages={ReceiptVoucherTotalPage}
          onPageChange={(page) => {
            searchReceiptVoucher(token, user_id, {
              page,
              from_date: from_date,
              to_date: to_date,
              branch_id: branch,
              currency_id: currency,
              party_name: party_name,
              status: remittance_status,
            });
          }}
        />
      </div>


      {/* View Modal */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Remittance Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {loadingDetails ? (
            <div className="text-center">
              <Spinner animation="border" />
            </div>
          ) : remittanceDetails ? (
            <>
              <div className="row mb-3">
                <div className="col-md-6">
                  <p><strong>Remittance No:</strong> {remittanceDetails.remittance_id}</p>
                  <p><strong>Date:</strong> {remittanceDetails.remittance_date?.split("T")[0]}</p>
                  <p><strong>Status:</strong> {remittanceDetails.status}</p>
                  <p><strong>Posting Status:</strong> {remittanceDetails.remittance_status}</p>
                </div>

                <div className="col-md-6">
                  <p><strong>Total Amount:</strong> {remittanceDetails.total_amount}</p>
                  <p><strong>Net Remittance:</strong> {remittanceDetails.net_remittance}</p>
                  <p><strong>Bank Charge:</strong> {remittanceDetails.bank_charge}</p>
                  <p><strong>Exchange Variance:</strong> {remittanceDetails.exchange_variance}</p>
                </div>
              </div>

              <hr />

              <h6>Invoices</h6>

              <BootstrapTable bordered hover responsive>
                <thead>
                  <tr>
                    <th>Party</th>
                    <th>Voucher No</th>
                    <th>Date</th>
                    <th>Original</th>
                    <th>Balance</th>
                    <th>Adjusted</th>
                    <th>Effective Date</th>
                  </tr>
                </thead>
                <tbody>
                  {remittanceDetails.invoices_for_clubbing?.map((item, i) => (
                    <tr key={i}>
                      <td>{item.party_name}</td>
                      <td>{item.voucher_no}</td>
                      <td>{item.voucher_date}</td>
                      <td>{item.original_amount}</td>
                      <td>{item.balance}</td>
                      <td>{item.adjusted_amount}</td>
                      <td>{item.effective_date}</td>
                    </tr>
                  ))}
                </tbody>
              </BootstrapTable>
            </>
          ) : (
            <p>No data found</p>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default VoucherProcessingReceiptSearch;
